:host {
  .support-premium-ad {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 8px 16px;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    p {
      color: var(--font-primary);
      font-size: 16px;
      font-weight: 500;
    }
    a {
      text-decoration: none;
      font-size: 14px;
      font-weight: 400;
      color: var(--blue-link);
    }
  }
}
